/* eslint no-unused-vars: 0 */

import React      from 'react';
import Geocoder   from './Geocoder';
import PropTypes  from 'prop-types';

class Autocomplete extends React.Component {
  render() {
    return (
      <div>
        <Geocoder
          accessToken={'pk.eyJ1IjoiYWhhcm9ud2Fzc2VybWFuIiwiYSI6ImNpenlsN2xvdTAwYmYyd215cDY0bjV5YXEifQ.NJxXuAzP3xJIClft9z5LKA'}
          onSelect={ this.props.onSelect.bind(this) }
          inputClass="form-field"
          inputPlaceholder="Search places..."
          resultsClass="autocomplete-results"
          resultClass="autocomplete-result"
        />
      </div>
    );
  }
}

Autocomplete.propTypes = {
  onSelect: PropTypes.func
};

export default Autocomplete;



// WEBPACK FOOTER //
// ./client/components/Autocomplete.js